import NetworkCall from "network/networkCall";
import Request from "network/request";
import { camelCaseKeysRecursively } from "utilities/generalUtility";

export default class BillingApproval {
  static async getJobSubmittedBillings(clientId, params) {
    return NetworkCall.fetch(Request.getJobSubmittedBillings(clientId, params));
  }

  static async getJobSubmittedBillingIds(clientId) {
    return NetworkCall.fetch(Request.getJobSubmittedBillingIds(clientId));
  }

  static async getClientSubmittedBillingIds(clientId) {
    return NetworkCall.fetch(Request.getClientSubmittedBillingIds(clientId));
  }

  static async getClientsSubmittedBillings(clientId, params) {
    return NetworkCall.fetch(
      Request.getClientsSubmittedBillings(clientId, params),
    );
  }

  static async getSubmittedBillHistory(payload) {
    const res = await NetworkCall.fetch(
      Request.getSubmittedBillHistory(payload),
    );
    return camelCaseKeysRecursively(res.data);
  }

  static async getJobBillingsTotal(clientId, params) {
    return NetworkCall.fetch(
      Request.v2.getJobBillingsTotal(clientId, params),
      false,
    );
  }

  static async getClientBillingsTotal(clientId, params) {
    return NetworkCall.fetch(
      Request.v2.getClientBillingsTotal(clientId, params),
      false,
    );
  }

  static async deleteClientSubmittedBill(billId) {
    return NetworkCall.fetch(Request.v2.deleteClientSubmittedBilling(billId));
  }

  static async deleteJobSubmittedBill(billId) {
    return NetworkCall.fetch(Request.v2.deleteJobSubmittedBilling(billId));
  }

  static async editJobSubmittedBilling(payload) {
    const res = await NetworkCall.fetch(
      Request.editJobSubmittedBilling(payload),
    );
    return camelCaseKeysRecursively(res.data);
  }

  static async editClientSubmittedBilling(payload) {
    const res = await NetworkCall.fetch(
      Request.editClientSubmittedBilling(payload),
    );
    return camelCaseKeysRecursively(res.data);
  }

  static async currencyConversion(payload) {
    const res = await NetworkCall.fetch(
      Request.currencyConversion(payload),
      false,
    );
    return camelCaseKeysRecursively(res.data);
  }

  static async generateInvoice(payload) {
    return NetworkCall.fetch(Request.generateBillingInvoice(payload));
  }

  static async issueJobCredit(body) {
    const res = await NetworkCall.fetch(Request.issueJobCredit(body));
    return camelCaseKeysRecursively(res.data);
  }

  // Recalcuate offer salary Billing
  static async submitReCalculateBilling(
    billingRuleEntryId,
    candidateJobEntryId,
    salary,
  ) {
    const res = await NetworkCall.fetch(
      Request.submitReCalculateBillings(
        billingRuleEntryId,
        candidateJobEntryId,
        salary,
      ),
    );
    return camelCaseKeysRecursively(res.data);
  }

  // Runtime calcuate offer salary Billing
  static async submitRunTimeCalculation(
    billingRuleEntryId,
    candidateJobEntryId,
    salary,
  ) {
    const res = await NetworkCall.fetch(
      Request.submitRunTimeCalculation(
        billingRuleEntryId,
        candidateJobEntryId,
        salary,
      ),
    );
    return camelCaseKeysRecursively(res.data);
  }

  // Calcuate discount
  static async calculateDiscount(body) {
    const res = await NetworkCall.fetch(Request.submitCalculateDiscount(body));
    return camelCaseKeysRecursively(res.data);
  }

  static async getVolumeBasedBillings(clientId, params, data, useLoading = true) {
    return NetworkCall.fetch(Request.getVolumeBasedBillings(clientId, params, data), useLoading);
  }
}
